export enum ErrorMessageTypeEnum {
	DEFAULT = 'error_default',
	ERROR_500 = 'error_500',
}

export const ErrorMessageTypeFromIndex: {[id: number]: ErrorMessageTypeEnum} = {
	0: ErrorMessageTypeEnum.DEFAULT,
	1: ErrorMessageTypeEnum.ERROR_500,
};
export default ErrorMessageTypeEnum;
